import React, { useEffect, useState } from "react";
import ReactJson from 'react-json-view'; // Import the JSON editor
import {
    appendToUrl,
    extractHTMLContent,
    fromWebBot,
    getQueryParamValue,
    isContentHTML, isInIframe,
    isMobile,
    parseJSON, publicChatData
} from "../App/utils";
import { MESSAGE, WS_MESSAGE } from "../App/constants";
import { kbUserDataLoaded, parseTS } from "../utils";
import { formatMessageDateChange, formatMessageTime, shouldShowDateDivider } from "./utils";
import Divider from "@mui/material/Divider";
import { colorGreen, colorEasyRed, colorGray, colorText } from "../App/theme";
import { Avatar, Box, CircularProgress, Tooltip, Typography, Menu, MenuItem } from "@mui/material";
import { UserAvatar } from "../User/UserAvatar";
import { getKBImage } from "../KB/KBImage";
import { MessageReactions } from "./MessageReactions";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import { handleShare, ShareChatDialog } from "./ChatMessagesHelpers";
import {
    AddReactionOutlined,
    DataObject,
    Edit,
    Image,
    ShareOutlined,
    MoreVert,
    VolumeUp,
    Visibility,
    Html,
    Download
} from "@mui/icons-material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmIconButton } from "../Components/ConfirmIconButton";
import { chatDeleteMessage, chatEditMessage } from "../API/chatAPI";
import {fetchAndPlayAudio, TextToSpeechPlayer} from "./TextToSpeechPlayer";
import * as itemsAPI from "../API/items/itemsAPI";
import {getJSONTheme} from "../ContentWidgets/JSONComponent";

const regexImages = /(https?:\/\/[^\s]+\.(?:gif|jpe?g|tiff?|png|webp|bmp))/g;
let avatarSize = fromWebBot ? 150 : (isMobile ? '48px' : '64px');
const avatarStyle = { width: avatarSize, height: avatarSize, borderRadius: '50%' };
const disabledHTML = getQueryParamValue('disableHTML');

let lastLocalMessageAction = null;
export const hasRecentMessageAction = () => (lastLocalMessageAction > (+new Date() - 5000));

// Helper to strip GEMINI_META from content
const stripGeminiMeta = (content) => {
    if (!content || typeof content !== 'string') return content;
    const metaTagIndex = content.indexOf('<!--GEMINI_META');
    if (metaTagIndex !== -1) {
        return content.substring(0, metaTagIndex);
    }
    return content;
};

export const ChatMessage = ({
                                index, messagesToRender, messages, rect,
                                isStreaming, boxRef, setMessages,
                                chatId, userPictureURL, sharedChat, KBId, setActiveEmojiMenu, avatars,
                                setLoading, setOgImage, setShareDetails, shareDetails, ogImage, KB,
                                renderSettings, contentRenderLoaded, setBlockingLoading
                            }) => {
    const [editingMessage, setEditingMessage] = useState(null);
    const [deletingMessage, setDeletingMessage] = useState(null);
    const [loadingButton, setLoadingButton] = useState(false);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const message = messagesToRender[index];
    const msgId = message?.msgId;
    const originalContent = stripGeminiMeta(messages[index]?.content);
    const JSONMessage = parseJSON(originalContent);
    const hasToJSON = JSONMessage?.type === MESSAGE.TEXT_DETECTIONS && JSONMessage?.view !== "JSON";
    const hasToVisual = JSONMessage?.type === MESSAGE.TEXT_DETECTIONS && JSONMessage?.view && JSONMessage?.view !== "VISUAL";
    const isJSONGRID = JSONMessage?.type === MESSAGE.JSON_GRID;
    const isImageEditor = JSONMessage?.type === MESSAGE.IMAGE_EDITOR;
    const hasImageEditor = !!KB?.inputTools?.find(o => parseJSON(o)?.type === 'imageEditor');
    const [loadingTextToSpeech, setLoadingTextToSpeech] = useState(false);

    const [showEventLoader, setShowEventLoader] = useState(false);

    useEffect(() => {
        let timer;
        if (JSONMessage?._meta_type === "EVENT_STARTED") {
            timer = setTimeout(() => {
                setShowEventLoader(true);
            }, 1000);
        }

        return () => clearTimeout(timer);
    }, [JSONMessage]);

    let width = isMobile ? '95%' : '75%';
    let paddingLeft;
    if (typeof originalContent === 'string' && originalContent?.match(regexImages) && !isMobile) width = '69%';
    if (isImageEditor) {
        width = isMobile ? '99%' : '69%';
        // fix problem with menu overlapping the image
        if (!isMobile && rect?.left && (300 - rect?.left) > 0) {
            paddingLeft = (300 - rect?.left)
        }
    }

    if (fromWebBot) width = '100%';
    if (!message?.content) return null;
    if (isJSONGRID) width = '98%';

    if (renderSettings?.setMessageWidth) {
        const newWidth = renderSettings?.setMessageWidth(originalContent);
        if (newWidth) width = newWidth
    }


    const prevTimestamp = messagesToRender?.[index - 1]?.msgId ? parseTS(messagesToRender[index - 1]?.msgId) : null;
    const timestamp = message?.msgId && parseTS(message?.msgId);
    const showDivider = message?.role === 'user' && timestamp && shouldShowDateDivider(timestamp, prevTimestamp);

    const confirmItem = (deletingMessage || editingMessage);
    const isConfirm = confirmItem && confirmItem?.msgId === message?.msgId

    const isLastOriginalMessage = (index === (messages?.length - 1))

    const lastMsgJustAppeared = isLastOriginalMessage &&
        message?.userId !== 'User_' + kbUserDataLoaded?.myUserId &&
        (+new Date() - parseTS(message.msgId)) < 5000;

    const setContentView = (index, view) => {
        setMessages(prevMessages => {
            return prevMessages.map((message, i) => i === index
                ? { ...message, content: JSON.stringify({ ...parseJSON(message?.content), view }) }
                : message);
        });
    };

    const startEditing = (message) => {
        setEditingMessage({
            ...message,
            content: stripGeminiMeta(message?._content)
        });
    };

    const handleEditChange = (event) => {
        setEditingMessage(prev => ({ ...prev, content: event.target.value }));
    };

    const confirmDelete = async () => {
        lastLocalMessageAction = +new Date();
        if (msgId) {
            if (!hasImageEditor) {
                chatDeleteMessage(chatId, msgId).then()
                if (contentRenderLoaded?.onDeleteChatMessage) {
                    contentRenderLoaded.onDeleteChatMessage({
                        KB,
                        chatId,
                        message: {...message, content: originalContent},
                        itemsAPI,
                        setBlockingLoading
                    })
                }
            }
            setMessages(prevMessages => prevMessages.filter((o, i) => o?.msgId !== msgId));
            setDeletingMessage(null);
        }
    };

    const confirmEdit = async () => {
        lastLocalMessageAction = +new Date();
        if (msgId) {
            setLoadingButton(true);
            await chatEditMessage(chatId, msgId, editingMessage.content);
            setLoadingButton(false);
            setMessages(prevMessages => prevMessages.map(msg => msg.msgId === msgId ? { ...msg, content: editingMessage.content } : msg));
            setEditingMessage(null);
        }
    };

    if (JSONMessage?._meta_type === "EVENT_STARTED") {
        return !!showEventLoader && <CircularProgress key={message.msgId} size={32} style={{ left: 0 }} />
    }

    const isAssistant = message?.role?.startsWith('assistant');

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuOpen(false);
    };

    const ConfirmButtons = (
        <div>
            {editingMessage && <Box style={{ padding: '2px 4px 0px 0px' }}>
                {!loadingButton && <ConfirmIconButton
                    title='Cancel'
                    onClick={() => setEditingMessage(null)}
                />}

                <ConfirmIconButton
                    disabled={!editingMessage.content}
                    color={colorGreen}
                    loading={loadingButton}
                    title='Save'
                    onClick={confirmEdit}
                />
            </Box>}

            {deletingMessage && <Box style={{ padding: '2px 4px 0px 0px' }}>
                {!loadingButton && <ConfirmIconButton
                    title='Cancel'
                    onClick={() => setDeletingMessage(null)}
                />}

                <ConfirmIconButton
                    color={colorEasyRed}
                    loading={loadingButton}
                    title='Delete'
                    onClick={confirmDelete}
                />
            </Box>}
        </div>
    );

    return (
        <React.Fragment key={message.msgId}>
            {showDivider &&
                <Divider key={index + 'dateChange'} style={{
                    padding: '32px 0px 32px 0px',
                    color: colorGray
                }}>
                    {formatMessageDateChange(timestamp)}
                </Divider>}
            <Box
                key={index}
                pb={1}
                display="flex"
                alignItems="center"
            >
                {/* Message with avatar */}
                <Box display="flex"
                     alignItems="flex-start"
                     ref={boxRef}
                     position="relative"
                     className={`${lastMsgJustAppeared ? 'message-enter-left ' : ''}messageItem`}
                     style={{ width, paddingLeft }}>

                    {/* Avatar */}
                    {!isImageEditor && !renderSettings?.disableChatAvatar && (
                        message.role === 'system'
                            ? <div style={avatarStyle} />
                            : message.role === 'user'
                                ? message?.userId && <>
                                <UserAvatar
                                    KB={KB}
                                    key={message?.userId}
                                    alt="User"
                                    msgUserId={message?.userId?.split?.('_')?.[1]}
                                    picture={userPictureURL}
                                    style={avatarStyle}
                                />
                            </>
                                : <Avatar alt="AI" src={sharedChat?.avatars?.assistant || getKBImage(KBId)} style={avatarStyle} />
                    )
                    }

                    {/* Message Header */}
                    {
                        message?.msgId &&
                        <Box style={{
                            position: 'absolute',
                            marginLeft: renderSettings?.disableChatAvatar ? (isMobile ? '12px' : '22px') : (isMobile ? '60px' : '82px'),
                            marginTop: '8px',
                            color: colorGray,
                            fontSize: isMobile ? 12 : 12
                        }}>{formatMessageTime(timestamp, renderSettings)} {message.updatedAt && ` (edited)`}</Box>}

                    {/* Message Left Footer */}
                    <Box style={{
                        position: 'absolute',
                        marginLeft: isMobile ? '60px' : '82px',
                        bottom: 4,
                        marginTop: '8px',
                        color: colorGray,
                        fontSize: isMobile ? 12 : 12
                    }}>
                        <MessageReactions reactions={message.reactions} {...{ message, setMessages, chatId }} />
                        {message.sent && isLastOriginalMessage && !message.reactions && !renderSettings?.disableSentLabel && ` Sent`}
                    </Box>

                    {/* Message Container */}
                    <Box display="flex" alignItems="flex-start" position="relative"
                         className={`${lastMsgJustAppeared ? 'message-enter ' : ''}itemHover ${isMobile ? 'alwaysHover' : ''}`}
                         style={{
                             borderRadius: '5px',
                             left: isMobile ? 5 : 10,
                             paddingTop: 10,
                             width,
                             paddingBottom: 10
                         }}
                    >

                        {editingMessage ? (
                            <Box display="flex" alignItems="center" style={{ width: '100%' }}>
                                {parseJSON(editingMessage?.content) ? (
                                    <ReactJson
                                        theme={getJSONTheme()}
                                        src={parseJSON(editingMessage.content)}
                                        onEdit={(edit) => setEditingMessage(prev => ({ ...prev, content: JSON.stringify(edit.updated_src) }))}
                                        onAdd={(add) => setEditingMessage(prev => ({ ...prev, content: JSON.stringify(add.updated_src) }))}
                                        onDelete={(del) => setEditingMessage(prev => ({ ...prev, content: JSON.stringify(del.updated_src) }))}
                                        style={{ width: '100%', backgroundColor: 'transparent', color: 'inherit', textAlign: 'left', paddingTop: '40px' }}

                                    />
                                ) : (
                                <TextField
                                    autoFocus
                                    fullWidth
                                    multiline={true}
                                    variant="outlined"
                                    value={editingMessage.content}
                                    onChange={handleEditChange}
                                    onKeyDown={(e) => (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) && confirmEdit()}
                                    sx={{
                                        paddingTop: '14px',
                                        paddingBottom: '13px',
                                        '& .MuiInputBase-input': {
                                            height: '30px',
                                            padding: '0px 0px',
                                            //fontSize: '0.875rem',
                                            lineHeight: '28px',
                                            backgroundColor: 'transparent',
                                            color: 'inherit',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            minHeight: '30px',
                                            backgroundColor: 'transparent',
                                            '& fieldset': {
                                                border: 'none',
                                            },
                                            '&:hover fieldset': {
                                                border: 'none',
                                            },
                                            '&.Mui-focused fieldset': {
                                                border: 'none',
                                            },
                                        },
                                    }}
                                />
                                )}
                            </Box>
                        ) : (
                            <Typography variant="subtitle1" style={{
                                //fontSize: '0.875rem',
                                color: colorText,
                                marginLeft: 8,
                                marginTop: 14,
                                marginBottom: 14,
                                textAlign: 'left',
                                flexGrow: 1
                            }}>
                                {message?.type === WS_MESSAGE.USER_TYPING
                                    ? <div style={{ paddingBottom: '40px' }} className="typing-animation"><span></span><span></span><span></span></div>
                                    : message.content
                                }
                            </Typography>
                        )}

                        {/* Message Top Icons */}
                        {!isStreaming && !isMobile && (
                            <div className={`showItems ${isMobile ? 'alwaysVisible' : ''}`}
                                 style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

                                {/*{!sharedChat && !isConfirm && isContentHTML(originalContent) && !renderSettings?.disableHTMLButton && <IconButton onClick={() => {*/}
                                {/*    window.location.href = appendToUrl(window.location.href, 'disableHTML', disabledHTML ? '' : '1')*/}
                                {/*}} >*/}
                                {/*    {disabledHTML && <Visibility style={{ color: 'grey', fontSize: 16 }} />}*/}
                                {/*    {!disabledHTML && <Html style={{ color: 'grey', fontSize: 16 }} />}*/}
                                {/*</IconButton>}*/}

                                {!sharedChat && !isConfirm && false && !renderSettings?.disableTextToSpeechButton && <TextToSpeechPlayer text={originalContent} KB={KB} style={{ color: 'grey', fontSize: 16 }} /> }

                                {!sharedChat && !isConfirm && !renderSettings?.disableShareButton && <IconButton onClick={() => {
                                    handleShare({
                                        messagesToShare: messages,
                                        avatars,
                                        KBId,
                                        setLoading,
                                        setOgImage,
                                        setShareDetails
                                    });
                                }} >
                                    <ShareOutlined style={{ color: 'grey', fontSize: 16 }} />
                                </IconButton>}

                                {!sharedChat && !isConfirm && !renderSettings?.disableTextToSpeechButton && (
                                    <IconButton onClick={async () => {
                                        await fetchAndPlayAudio({setLoading: setLoadingTextToSpeech, text: originalContent, KB})
                                        handleMenuClose();
                                    }}>
                                        {!loadingTextToSpeech
                                            ? <VolumeUp style={{ color: 'grey', fontSize: 16 }} />
                                            : <CircularProgress size={16} style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />}
                                    </IconButton>
                                )}

                                {!hasToVisual && !hasToJSON && !isImageEditor && !isConfirm && !renderSettings?.disableCopyButton &&
                                    !sharedChat && !isInIframe() &&
                                    // (false && isContentHTML(originalContent))
                                    //     ? <IconButton   onClick={() => {
                                    //             const blob = new Blob([extractHTMLContent(originalContent)], { type: 'text/html' });
                                    //             const link = document.createElement('a');
                                    //             link.href = URL.createObjectURL(blob);
                                    //             link.download = 'index.html';
                                    //             link.click();
                                    //     }} >
                                    //         <Download style={{ color: 'grey', fontSize: 16 }} />
                                    //       </IconButton>
                                    //     :
                                          <IconButton onClick={() => navigator.clipboard.writeText(originalContent)} >
                                            <FileCopyIcon style={{ color: 'grey', fontSize: 16 }} />
                                          </IconButton>
                                }

                                {hasToVisual && <IconButton
                                    onClick={() => setContentView(index, "VISUAL")}
                                >
                                    <Image style={{ color: 'grey', fontSize: 16 }} />
                                </IconButton>}

                                {hasToJSON && !isConfirm &&
                                    <IconButton onClick={() => setContentView(index, "JSON")}
                                    >
                                        <DataObject style={{ color: 'grey', fontSize: 16 }} />
                                    </IconButton>
                                }

                                {!hasToVisual && !hasToJSON && !isImageEditor && !isConfirm &&
                                    (typeof message?._content === 'string' && <IconButton onClick={() => startEditing(message)}
                                    >
                                        <Edit style={{ color: 'grey', fontSize: 16 }} />
                                    </IconButton>)
                                }

                                {!isConfirm && message.msgId && <IconButton onClick={() => setDeletingMessage(message)}>
                                    {!isImageEditor && <DeleteIcon style={{ color: 'grey', fontSize: 16 }} />}
                                </IconButton>}

                                {ConfirmButtons}
                            </div>
                        )}
                        {/* Mobile Menu */}
                        {!isStreaming && isMobile && !publicChatData && (
                            <div className={`showItems ${isMobile ? 'alwaysVisible' : ''}`}
                                 style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

                                {!isConfirm && <IconButton onClick={handleMenuOpen}>
                                    <MoreVert style={{ color: 'grey', fontSize: 16 }} />
                                </IconButton>}
                                <Menu
                                    anchorEl={menuAnchorEl}
                                    open={menuOpen}
                                    onClose={handleMenuClose}
                                >
                                    {!sharedChat && !isConfirm && !renderSettings?.disableTextToSpeechButton && (
                                        <MenuItem onClick={async () => {
                                            //
                                            await fetchAndPlayAudio({setLoading: setLoadingTextToSpeech, text: originalContent, KB})
                                            handleMenuClose();
                                        }}>
                                            {!loadingTextToSpeech
                                                ? <VolumeUp style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                                : <CircularProgress size={16} style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />}
                                            Play
                                        </MenuItem>
                                    )}

                                    {!sharedChat && !isConfirm && !renderSettings?.disableShareButton && (
                                        <MenuItem onClick={() => {
                                            handleShare({
                                                messagesToShare: messages,
                                                avatars,
                                                KBId,
                                                setLoading,
                                                setOgImage,
                                                setShareDetails
                                            });
                                            handleMenuClose();
                                        }}>
                                            <ShareOutlined style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            Share
                                        </MenuItem>
                                    )}

                                    {!hasToVisual && !hasToJSON && !isImageEditor && !isConfirm && !renderSettings?.disableCopyButton && (
                                        <MenuItem onClick={() => {
                                            navigator.clipboard.writeText(originalContent);
                                            handleMenuClose();
                                        }}>
                                            <FileCopyIcon style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            Copy
                                        </MenuItem>
                                    )}

                                    {hasToVisual && (
                                        <MenuItem onClick={() => {
                                            setContentView(index, "VISUAL");
                                            handleMenuClose();
                                        }}>
                                            <Image style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            View as Image
                                        </MenuItem>
                                    )}

                                    {hasToJSON && !isConfirm && (
                                        <MenuItem onClick={() => {
                                            setContentView(index, "JSON");
                                            handleMenuClose();
                                        }}>
                                            <DataObject style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            View as JSON
                                        </MenuItem>
                                    )}

                                    {!hasToVisual && !hasToJSON && !isImageEditor && !isConfirm && (
                                        <MenuItem onClick={() => {
                                            startEditing(message);
                                            handleMenuClose();
                                        }}>
                                            <Edit style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            Edit
                                        </MenuItem>
                                    )}

                                    {!isConfirm && message.msgId && (
                                        <MenuItem onClick={() => {
                                            setDeletingMessage(message);
                                            handleMenuClose();
                                        }}>
                                            <DeleteIcon style={{ color: 'grey', fontSize: 16, marginRight: 8 }} />
                                            Delete
                                        </MenuItem>
                                    )}
                                </Menu>
                                {ConfirmButtons}
                            </div>
                        )}

                        {!isStreaming && <div className={`showItemsDown ${isMobile ? 'alwaysVisible' : ''}`}
                                              style={{
                                                  position: 'absolute',
                                                  bottom: 0,
                                                  right: 0,
                                                  zIndex: 0,
                                                  padding: '2px',
                                                  display: 'flex',
                                                  justifyContent: 'flex-end',
                                                  alignItems: 'flex-end',
                                              }}>

                            {/* Message Top Button */}
                            {!sharedChat && JSONMessage?.type !== 'IMAGE_EDITOR' && !renderSettings?.disableEmojiButton &&
                                <Tooltip title={'Add Reaction'}>
                                    <IconButton onClick={() => setActiveEmojiMenu(message?.msgId)}>
                                        <AddReactionOutlined style={{ color: 'grey', fontSize: 16 }} />
                                    </IconButton>
                                </Tooltip>
                            }
                        </div>}
                    </Box>
                </Box>
                {shareDetails?.url && <ShareChatDialog {...{ shareDetails, ogImage, setShareDetails }} />}
            </Box>
        </React.Fragment>
    )
}